/*
 * Aura bottom navigation — cart count mirror. 17 Sep 2026.
 *
 * The bar shows a cart count. Rendering an independent counter from
 * cart.item_count would be correct exactly once: the drawer adds items without
 * a page load, so the number would go stale the moment anyone used it, and a
 * wrong cart count is worse than none.
 *
 * The header's #cart-icon-bubble is already kept current by the theme — the
 * cart drawer re-renders it through the Section Rendering API on every change.
 * So this mirrors that element rather than tracking the cart itself: one source
 * of truth, and no assumptions about which events the theme happens to fire.
 */
(function () {
  'use strict';

  function readCount() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return null;
    // The count lives in a nested span whose class differs between themes, so
    // take the first integer in the element's text rather than guessing at it.
    var m = (bubble.textContent || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  function paint() {
    var out = document.querySelector('[data-aura-bnav-count]');
    if (!out) return;
    var n = readCount();
    if (n === null) return;              // no header bubble: leave server value
    out.textContent = n;
    if (n > 0) out.removeAttribute('hidden');
    else out.setAttribute('hidden', '');
  }

  function start() {
    if (!document.querySelector('[data-aura-bnav-count]')) return;
    paint();

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && 'MutationObserver' in window) {
      // The drawer REPLACES the bubble's subtree, so watch the subtree and the
      // characterData, not just direct children.
      new MutationObserver(paint).observe(bubble, {
        childList: true, subtree: true, characterData: true
      });
    }
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('pageshow', paint);   // bfcache restore
})();
